import {
  GET_NEW_BY_CATE,
  POST_NEW,
  GET_NEW_BY_ID,
  GET_NEW_BY_SLUG,
  PUT_NEW,
  PUT_LIST_NEW,
  DELETE_NEW,
  SEARCH_NEW,
  POST_PRODUCT_NEWS,
  DELETE_PRODUCT_NEWS,
} from '../type';

const initialState = {
  listNews: [],
  countNew: null,
  dataNew: null,
  searchDataNew: [],
  countDateNew: 0,
};

const news = (state = initialState, action) => {
  switch (action.type) {
    case GET_NEW_BY_CATE:
      return {
        ...state,
        // API /news trả { data, count }, không phải { listNews, countNew }
        listNews: action.data.data,
        countNew: action.data.count,
      };
    case POST_NEW:
      return {
        ...state,
        listNews: [...state.listNews, action.data],
      };
    case GET_NEW_BY_ID:
      return {
        ...state,
        dataNew: action.data,
      };
    case GET_NEW_BY_SLUG:
      return {
        ...state,
        dataNew: action.data,
      };
    case PUT_NEW:
      return {
        ...state,
        listNews: state.listNews.map((item) => (item._id === action.data._id ? (item = action.data) : item)),
      };
    case PUT_LIST_NEW:
      return {
        ...state,
      };
    case DELETE_NEW:
      return {
        ...state,
        listNews: state.listNews.filter((item) => item._id !== action.data._id),
      };
    case SEARCH_NEW:
      return {
        ...state,
        searchDataNew: action.data.result,
        countDateNew: action.data.count,
      };
    case POST_PRODUCT_NEWS:
      return {
        ...state,
      };
    case DELETE_PRODUCT_NEWS:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default news;
